<template>
  <div class="dialog" v-show="isShow">
    <div class="dialog-wrap">
      <div class="dialog-header clearfix">
        <img class="pull-right" src="/static/img/dialog_close.png" alt="" @click="isShow=false">
        <div class="doalog-text">
          <p style="margin-bottom:15px;">欢迎访问<span class="stress">伟嘉安捷官方网站</span>！</p>
          <p>有什么可以帮助您的吗？</p>
        </div>
      </div>
      <div class="dialog-footer">
        <span class="later" @click="isShow=false">稍后再说</span>
        <span class="counsel" @click="onclick">现在咨询</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        isShow: true
      }
    },
    methods: {
      onclick () {
        window.doyoo.util.openChat('g=10066289')
        this.isShow = false
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
.dialog
  position fixed
  z-index 1000
  left 50%
  top 50%
  margin -117px -225px
  box-shadow 0px 1px 15px 3px rgba(0,0,0,0.16)
  border-radius 5px
  .dialog-wrap
    width 451px
    height 234px
    background-color #ffffff
    border-radius 5px
    .dialog-header
      height 178px
      border-bottom 1px solid #e8e8e8
      padding-top 16px
    .doalog-text
      padding-top 44px
    .pull-right
      margin-right 16px
      cursor pointer
    .stress
        color #0068b7
      p
        margin 0
        text-align center
        font-size 26px
        font-family "Microsoft YaHei"
    .dialog-footer
      font-size 0
    .dialog-footer span
      display inline-block
      width 50%
      text-align center
      height 56px
      line-height 56px
      cursor pointer
    .later
      font-family "Microsoft YaHei"
      font-size  20px
      color #999
    .counsel
      font-family "Microsoft YaHei"
      font-size  20px
      color #fefefe
      background-color #2B9EFC
      border-radius 0 0 5px 0

</style>



// WEBPACK FOOTER //
// dialog.vue?4f900f62